import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import MobileBottomNav from './MobileBottomNav';
import LiveChat from './LiveChat';
import { applySeo } from '../utils/seo';
import { preloadForRoute, prefetchAdjacentAssets } from '../utils/imagePreload';
import { trackEvent, Events, setNativeChrome } from '../utils/webviewBridge';
import './Layout.css';

const BARE_PATHS = ['/onboarding', '/paywall'];

const Layout = ({ children }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    trackEvent(Events.PAGE_VIEW, { path: pathname });
  }, [pathname]);

  useEffect(() => {
    preloadForRoute(pathname);
    prefetchAdjacentAssets(pathname);
  }, [pathname]);

  useEffect(() => {
    // News articles set richer meta themselves
    if (pathname.startsWith('/news/') && pathname !== '/news/') return;
    applySeo({ path: pathname });
  }, [pathname]);

  const isBare = BARE_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`)
  );

  // Restore site + native chrome on normal pages (undo onboarding hide)
  useEffect(() => {
    if (isBare) {
      document.body.classList.add('lf-onboarding');
      setNativeChrome({
        hideBottomNav: true,
        hideChrome: true,
        screen: pathname.startsWith('/paywall') ? 'paywall' : 'onboarding'
      });
      return () => {
        document.body.classList.remove('lf-onboarding', 'lf-hide-bottom-nav', 'lf-bare-chrome');
        setNativeChrome({ hideBottomNav: false, hideChrome: false, screen: null });
      };
    }

    document.body.classList.remove('lf-onboarding', 'lf-hide-bottom-nav', 'lf-bare-chrome');
    setNativeChrome({ hideBottomNav: false, hideChrome: false, screen: null });
    return undefined;
  }, [isBare, pathname]);

  if (isBare) {
    return (
      <div className="app-layout app-layout--bare" data-bare="1">
        {children}
      </div>
    );
  }

  return (
    <div className="app-layout">
      <Header />
      <main className="app-main">{children}</main>
      <Footer />
      <MobileBottomNav />
      <LiveChat />
    </div>
  );
};

export default Layout;
